import type {
  EGiftCardCreateItemRequest,
  EGiftCardUpdateItemRequest,
  MerchantEGiftCard,
} from "../types/eGiftCard.types";

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function normalizeGiftCardId(id: string): string {
  const [idWithoutPoints] = id.split("_$", 1);
  return UUID_PATTERN.test(idWithoutPoints) ? idWithoutPoints : id;
}

export function toEGiftCardCreateItems(
  giftCards: MerchantEGiftCard[],
): EGiftCardCreateItemRequest[] {
  return giftCards.map(({ coupon_id, quantity, points, faceValue }) => ({
    coupon_id: coupon_id ?? "",
    quantity,
    points,
    price: faceValue,
  }));
}

export function toEGiftCardUpdateItems(
  giftCards: MerchantEGiftCard[],
): EGiftCardUpdateItemRequest[] {
  return giftCards.map(({ id, coupon_id, quantity, points, faceValue }) => ({
    merchant_brand_item_id: normalizeGiftCardId(id ?? ""),
    coupon_id: coupon_id ?? "",
    quantity,
    points,
    price: faceValue,
  }));
}
